/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Overlapping_Events_TextInputs */

const en_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subtitle file you are importing has overlapping events. Would you like to fix them?`)
};

const fr_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fichier de sous-titres que vous importez contient des evenements qui se chevauchent. Souhaitez-vous les corriger?`)
};

const de_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die importierte Untertiteldatei enthält überlappende Ereignisse. Möchten Sie diese beheben?`)
};

const it_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il file dei sottotitoli che stai importando presenta eventi sovrapposti. Vuoi correggerli?`)
};

const ru_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В импортируемом файле субтитров присутствуют наложения событий. Хотите ли вы их исправить?`)
};

const es_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo de subtítulos que estás importando tiene eventos superpuestos. ¿Quieres corregirlos?`)
};

const zh_cn2_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您导入的字幕文件存在重叠事件。是否要修复这些问题？`)
};

const ja_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート中の字幕ファイルには重複したイベントがあります。修正しますか？`)
};

const hi_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप जिस सबटाइटल फ़ाइल को इंपोर्ट कर रहे हैं, उसमें कुछ इवेंट ओवरलैप हो रहे हैं। क्या आप उन्हें ठीक करना चाहेंगे?`)
};

const pt_pt2_editor_overlapping_events_text = /** @type {(inputs: Editor_Overlapping_Events_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O arquivo de legendas que você está importando contém eventos sobrepostos. Deseja corrigi-los?`)
};

/**
* | output |
* | --- |
* | "The subtitle file you are importing has overlapping events. Would you like to fix them?" |
*
* @param {Editor_Overlapping_Events_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_overlapping_events_text = /** @type {((inputs?: Editor_Overlapping_Events_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Overlapping_Events_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_overlapping_events_text(inputs)
	if (locale === "de") return de_editor_overlapping_events_text(inputs)
	if (locale === "it") return it_editor_overlapping_events_text(inputs)
	if (locale === "ru") return ru_editor_overlapping_events_text(inputs)
	if (locale === "es") return es_editor_overlapping_events_text(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_overlapping_events_text(inputs)
	if (locale === "ja") return ja_editor_overlapping_events_text(inputs)
	if (locale === "hi") return hi_editor_overlapping_events_text(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_overlapping_events_text(inputs)
	return en_editor_overlapping_events_text(inputs)
});